import React from "react";

const NotificationCenter = () => {
  return (
    <>
      <div className="notification-center" />
      <div className="notification-fader" />
    </>
  );
};

export default NotificationCenter;
